import { useState, useCallback, useEffect, useContext } from 'react';
import { endpoints } from '../../../utils/URL';
import axios from 'axios';
import { addToast } from '../../../utils/toastNotifications';
import { IPharmacyListDTO } from '../../../interface/PharmacyInterface';
import { ILoanApplicationList } from '../../../interface/LoanInterface';
import { AppContext } from '../../../context/AppContext';
import { IAppState } from '../../../interface/AppInterface';
import { NairaSymbol } from '../../../utils/mappings';
import { Link } from 'react-router-dom';
import NoDataView from '../../common/NoData';

const LoansPage = () => {
  const [data, setData] = useState<ILoanApplicationList[]>([]);
  const [pharmacyList, setPharmacyList] = useState<IPharmacyListDTO[]>([]);

  const { appState }: { appState: IAppState } = useContext(AppContext);
  const [pharmacyCode, setPharmacyCode] = useState('');

  const getLoanApplications = useCallback(async (pharmacyCode: string) => {
    let url = `${endpoints.loans.mainUrl}/applications/pharmacy/${pharmacyCode}`;

    try {
      const response = await axios.get(url);
      const loanData: ILoanApplicationList[] = response.data;

      setData(loanData);
    } catch (error) {
      addToast('Error fetching loans', 'error');
      setData([]);
    } finally {
    }
  }, []);

  const getPharmacyList = useCallback(async (clientId: number) => {
    try {
      const response = await axios.get(`${endpoints.pharmacies.mainUrl}/client/${clientId}/list`);
      const pharmacies = response.data as IPharmacyListDTO[];
      setPharmacyList(pharmacies);
    } catch (error) {
      addToast('Error fetching pharmacy list', 'error');
    }
  }, []);

  const changePharmacy = (event: any) => {
    const pharmacyCode = event.target.value;
    setPharmacyCode(pharmacyCode);
    setData([]);
    getLoanApplications(pharmacyCode);
  };

  useEffect(() => {
    getLoanApplications(appState.pharmacyCode);
    getPharmacyList(appState.clientId);
    setPharmacyCode(appState.pharmacyCode);
  }, [getLoanApplications, getPharmacyList, appState.pharmacyCode, appState.clientId]);

  let transactions = (
    <div className='row'>
      {data.map((loan, key) => (
        <Link to={`/loans/${loan.applicationId}`} key={key} className='col-12 mt-3 pointer'>
          <div style={{ fontWeight: 'bold' }}>{loan.dateCreated.split('T')[0]}</div>
          <div
            key={loan.applicationId}
            className={`card shadow ${
              loan.applicationStatus === 'Approved' ? 'text-success' : 'text-info'
            }`}
          >
            <div className='card-body py-4'>
              <div className='row fs-20'>
                <div className='col-md-3'>
                  <small className='text-dark me-1'>Loan Amount: </small>
                  {`₦ ${loan.principalApproved.toLocaleString()}`}
                </div>

                {/* <div className='col-sm-2'>{data.transactionStatus}</div> */}
                <div className='col-md-3 text-success'>
                  <small className='text-dark me-1'>Repaid: </small>
                  {NairaSymbol}
                  {loan.amountRepaid.toLocaleString()}
                </div>
                <div className='col-md-3 text-danger'>
                  <small className='text-dark me-1'>Pending: </small>
                  {NairaSymbol}
                  {loan.amountPending.toLocaleString()}
                </div>
                <div className='col-md-3'>
                  <small className='text-dark me-1'>Status: </small>
                  {loan.applicationStatus}
                </div>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );

  return (
    <div className='col-md-10  content-section'>
      {/* <PageTour
        steps={walletTourSteps}
        page='wallet'
        run={localStorage.getItem('walletTour') === 'completed' ? false : true}
      /> */}
      {/* Pharmacy Dropdown */}
      <div className='row ps-3 pe-3'>
        <div className='col-sm-6'>
          <div className='pharmacy-view'>
            <label>Select a Pharmacy to view</label>
            <select className='form-select' value={pharmacyCode} onChange={changePharmacy}>
              {pharmacyList.map((pharmacy) => (
                <option key={pharmacy.pharmacyId} value={pharmacy.pharmacyCode}>
                  {pharmacy.pharmacyName}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {/* Wallet Balance Cards */}
      <div className='col-12 my-5'>
        <div className='row'>
          <div className='col-md-6 col-lg-3 balance-view'>
            <div className='card shadow'>
              <div className='card-body'>
                <div className='text-start h5'>Total Loans</div>
                <div className={`text-center h5 $`}>{data.length.toLocaleString()}</div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-3 balance-view'>
            <div className='card shadow'>
              <div className='card-body'>
                <div className='text-start h5'>Total Amount</div>
                <div className={`text-center h5 text-success`}>
                  {NairaSymbol}
                  {data.reduce((a, b) => a + b.principalApproved, 0).toLocaleString()}
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-3 balance-view'>
            <div className='card shadow'>
              <div className='card-body'>
                <div className='text-start h5'>Total Repaid</div>
                <div className={`text-center h5  text-success`}>
                  {NairaSymbol}
                  {data.reduce((a, b) => a + b.amountRepaid, 0).toLocaleString()}
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-3 total-inflow'>
            <div className='card shadow'>
              <div className='card-body'>
                <div className='text-start h5'>Total Pending</div>
                <div className='text-center h5 text-danger'>
                  {NairaSymbol}
                  {data.reduce((a, b) => a + b.amountPending, 0).toLocaleString()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Transactions */}
      {data.length > 0 ? (
        <div className='col-12'>
          <div className='transaction-history'>
            <h4>All Loans</h4>
            <div className='justify-content-start'>{transactions}</div>
          </div>
        </div>
      ) : (
        <NoDataView />
      )}
    </div>
  );
};

export default LoansPage;
